var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 20.75H5.03125L17.25 8.53125L15.4688 6.75L3.25 18.9688V20.75ZM0.75 23.25V17.9375L17.25 1.46875C17.5 1.23958 17.776 1.0625 18.0781 0.9375C18.3802 0.8125 18.6979 0.75 19.0312 0.75C19.3646 0.75 19.6875 0.8125 20 0.9375C20.3125 1.0625 20.5833 1.25 20.8125 1.5L22.5312 3.25C22.7812 3.47917 22.9635 3.75 23.0781 4.0625C23.1927 4.375 23.25 4.6875 23.25 5C23.25 5.33333 23.1927 5.65104 23.0781 5.95312C22.9635 6.25521 22.7812 6.53125 22.5312 6.78125L6.0625 23.25H0.75ZM16.3438 7.65625L15.4688 6.75L17.25 8.53125L16.3438 7.65625Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b0600a1c93225315dc6a77553812471a.svg";
export { ForwardRef as ReactComponent };